import { useEffect, useState } from "react";
import clsx from "clsx";
import { linksConstants } from "../../../../constants/linksConstants";
import { animatePresenceConfig } from "../../../../config/appConfig";
import { Loader } from "../../../../platform/components/Loader/Loader";
import { AnimatePresence, motion } from "framer-motion";
import { sendGaEvent } from "../../../../config/userTracking";
import { AuthPagePaper } from "../../../../platform/views/Auth/components/AuthPagePaper";
import InputField from "@demystdata/ui/input_field";
import TextAreaField from "@demystdata/ui/textarea_field";
import Button from "@demystdata/ui/button";
import CheckboxField from "@demystdata/ui/checkbox_field";
import { validate } from "../../../utils/form-functions";
import { formAttribution } from "../../../../utils/formAttribution";
import { userApi } from "../../../../api/userApi";

export const LandingContactForm = ({ data }) => {
  const contactFormData = {
    fields: [
      { label: "Full name", id: "full_name", type: "text", component: "input", required: true },
      { label: "Business Email", id: "email", type: "email", component: "input", required: true },
      { label: "Company", id: "company", type: "text", component: "input", required: true },
      { label: "Role", id: "role", type: "text", component: "input", required: false },
      { label: "How can Demyst help you?", id: "message", component: "textarea", required: false },
    ],
    errors: {
      field_required: "This field is required!",
      incorrect_mail: "This email address is incorrect.",
    },
  };
  const handleContactFormSubmit = async e => {
    e.preventDefault();
    if (
      validate({ type: "contact", formData, data: contactFormData, changeErrors, consent }) === true
    ) {
      changeSending(true);

      const dataToSend = {
        type: "contact",
        formValues: preparedData(),
      };

      sendGaEvent(
        {
          action: "Form Submission",
          category: "Contact",
        },
        formData.email,
      );

      try {
        await userApi.sendFrontForm(dataToSend);
        changeSending(false);
        changeContactFormSent(true);
      } catch (e) {
        changeSending(false);
      }
    }
  };

  const [consent, changeConsent] = useState(false);
  const [formData, changeFormData] = useState({});
  const [errors, changeErrors] = useState({});
  const [sending, changeSending] = useState(false);
  const [contactFormSent, changeContactFormSent] = useState(false);

  const termsConditionsLabel = (
    <span>
      {"I agree to Demyst's "}
      <a href={linksConstants.PRIVACY} target="_blank" rel="noreferrer">
        Privacy Policy
      </a>
      {" and "}
      <a href={linksConstants.TERMS} target="_blank" rel="noreferrer">
        Terms and Conditions
      </a>
      .
    </span>
  );

  const changeData = (e, data) => {
    let newFormData = { ...formData };
    newFormData[data.id] = e;
    changeFormData(newFormData);
  };

  const preparedData = () => {
    let preparedData = formAttribution("Contact Form");
    contactFormData.fields.forEach(field => {
      preparedData[field.id] = formData[field.id];
    });
    return preparedData;
  };

  useEffect(() => {
    let newFormData = {};
    contactFormData.fields.forEach(field => {
      newFormData[field.id] = "";
    });
    changeFormData(newFormData);
  }, []);

  return (
    <div className={clsx("SignUp__paper", "LandingHero-form")}>
      <AuthPagePaper>
        <header className="SignUp__paper__header">
          <h2 className="SignUp__paper__header__title">
            {contactFormSent ? (
              <span>{data.form_sent_title || "Submission successful"}</span>
            ) : (
              <span>{data.form_title || "Contact us"}</span>
            )}
          </h2>
        </header>
        {contactFormSent && (
          <div className="SignUp__paper__header__message">
            {data.form_sent_message ? (
              <div dangerouslySetInnerHTML={{ __html: data.form_sent_message }} />
            ) : (
              <>
                <p>Thanks for reaching out. We will be in touch soon.</p>
              </>
            )}
          </div>
        )}
        {!contactFormSent && (
          <form onSubmit={handleContactFormSubmit} className="SignUpForm ContactForm">
            {contactFormData.fields.map((field, fieldIndex) => (
              <div className="SignUpForm__textfieldWrapper" key={fieldIndex}>
                {field.component === "input" && (
                  <InputField
                    size="regular"
                    name={field.id}
                    label={field.label}
                    id={field.id}
                    value={formData[field.id]}
                    error={errors[field.id]}
                    onChange={e => changeData(e, field)}
                    showRequiredAsterisk={false}
                    required={field.required}
                  />
                )}

                {field.component === "textarea" && (
                  <TextAreaField
                    size="regular"
                    value={formData[field.id]}
                    label={field.label}
                    onChange={e => changeData(e, field)}
                    error={errors[field.id]}
                    required={field.required}
                    showRequiredAsterisk={false}
                  />
                )}
              </div>
            ))}
            <CheckboxField
              label={termsConditionsLabel}
              name="acceptTerms"
              id="acceptTerms"
              size="regular"
              onChange={changeConsent}
              error={errors.consent}
              checkex={consent}
              required
            />
            <Button type="submit" size="large" fullWidth demystIcon variant="secondary">
              Submit
            </Button>
          </form>
        )}
        <AnimatePresence>
          {sending && (
            <motion.div className="SignUp__paper__loadingOverlay" {...animatePresenceConfig}>
              <Loader />
            </motion.div>
          )}
        </AnimatePresence>
      </AuthPagePaper>
    </div>
  );
};
